export default __webpack_public_path__ + "static/media/2.bbb41348.jpg";